/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation KeywordUploadMutation($keywordDirectoryId: ID, $keywords: [String!]!) {
  KeywordUpload(keywordDirectoryId: $keywordDirectoryId, keywords: $keywords) {
    id
    message
    status
  }
}
`
